import * as d3 from 'd3';

import { Log } from '../../../../models';

export function countByLevelByApp(logs: Log[]) {
    const byApp: { key: string, values: Log[] }[] = d3.nest<Log>()
        .key(d => d.application)
        .entries(logs);
    const table = byApp
        .map(d => {
            return {
                application: d.key,
                debug: d.values.filter(v => v.level === 'DEBUG').length,
                info: d.values.filter(v => v.level === 'INFO').length,
                warn: d.values.filter(v => v.level === 'WARN').length,
                error: d.values.filter(v => v.level === 'ERROR').length,
                fatal: d.values.filter(v => v.level === 'FATAL').length
            };
        })
        .sort((a, b) => a.application > b.application ? 1 : -1);
    return table;
}
